import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import ModalWindow from "Vue/components/lockDesigner/components/shared/Modals/ModalWindow.vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const componentName = 'LockDesignerWishlist';


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view),
    _createVNode(ModalWindow)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})